import {
  ApplicationPaginationToken,
  ApplicationTeammateList,
} from '../../../applications/bridge/v2/types/bridgeTypesV2';
import {serializeTeammateForApplication} from '../../../helpers/models/applicationSerializationHelpers';
import {ThunkAction} from '../../appThunk';
import {getFlatTeammates} from '../teammates/teammatesSelectors';

/*
 * Actions.
 */

export function applicationListTeammatesAction(
  _paginationToken?: ApplicationPaginationToken,
): ThunkAction<ApplicationTeammateList> {
  return (_dispatch, getState) => {
    const teammates = getFlatTeammates(getState());
    return {
      nextPageToken: undefined,
      results: teammates.map(serializeTeammateForApplication),
    };
  };
}
